import React, { createContext, useContext, useState, ReactNode } from 'react';
import { Language } from '@/components/LanguageSwitcher';
import { content, ContentType } from '@/data/content';

interface LanguageContextType {
  language: Language;
  setLanguage: (language: Language) => void;
  content: typeof content.sv | typeof content.en;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

interface LanguageProviderProps {
  children: ReactNode;
}

export const LanguageProvider: React.FC<LanguageProviderProps> = ({ children }) => {
  const [language, setLanguage] = useState<Language>('sv');
  const currentContent = content[language];

  const value = {
    language,
    setLanguage,
    content: currentContent,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};